import axios from 'axios';

class Api {
  constructor() {
    this.$api = axios.create({
      baseURL: process.env.VUE_APP_URL_API,
      timeout: 300000,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tkn')}`,
      },
    });
  }

  throwError = (err) => {
    const objError = {
      isConnection: false,
      isError500: false,
      is401: false,
      message: null,
    };

    const {
      code,
    } = err;

    if (code || !err.response) {
      objError.isConnection = true;
      objError.message = 'Ops!\n\n';
      objError.message += 'Não foi possível conectar com o servidor. ';
      objError.message += 'Verifique a sua internet e tente novamente!';
      return objError;
    }

    const {
      response: {
        status,
        data: {
          errors,
        },
      },
    } = err;

    if (!status || status !== 422) {
      if (status === 401) {
        objError.is401 = true;
      } else {
        objError.isError500 = true;
        objError.message = 'Ops!\n\nHouve um problema no processamento. Tente novamente!';
      }
      return objError;
    }

    objError.message = (errors.join(', ')).trim();
    return objError;
  }

  async get(url, params) {
    try {
      const request = await this.$api.get(url, {
        params,
      });

      return request.data;
    } catch (error) {
      throw this.throwError(error);
    }
  }

  async file(url, params) {
    try {
      const request = await this.$api.get(url, {
        params,
        responseType: 'blob',
      });

      return request.data;
    } catch (error) {
      throw this.throwError(error);
    }
  }

  async post(url, data, params) {
    try {
      const request = await this.$api.post(url, data, {
        params,
      });

      return request.data;
    } catch (error) {
      throw this.throwError(error);
    }
  }

  async put(url, data, params) {
    try {
      const request = await this.$api.put(url, data, {
        params,
      });

      return request.data;
    } catch (error) {
      throw this.throwError(error);
    }
  }

  async delete(url, params) {
    try {
      const request = await this.$api.delete(url, {
        params,
      });

      return request.data;
    } catch (error) {
      throw this.throwError(error);
    }
  }
}

export default new Api();
